module.exports = __webpack_public_path__ + "img/mining-pool-icon.eebdfc53.png";